export default {
    profile: null,
    select_data : null,
}